<script setup lang="ts">
interface Props {
  title: string;
  open?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  open: false,
});

const isOpen = ref(props.open);

function beforeEnterAndLeave(el: any) {
  el.style.height = "0";
}

function EnterAndBeforeLeave(el: any) {
  el.style.height = el.scrollHeight + "px";
}
</script>

<template>
  <div>
    <button
      class="w-full flex items-center justify-between p-2 border-b"
      type="button"
      @click="isOpen = !isOpen"
    >
      <span>{{ title }}</span>
      <Icon
        size="32"
        :name="isOpen ? 'mdi:triangle-small-up' : 'mdi:triangle-small-down'"
      />
    </button>
    <Transition
      name="accordion"
      @beforEnter="beforeEnterAndLeave"
      @enter="EnterAndBeforeLeave"
      @leave="beforeEnterAndLeave"
      @beforeLeave="EnterAndBeforeLeave"
    >
      <div class="target shadow overflow-hidden p-2" v-show="isOpen">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.target {
  transition: height 0.4s ease-in-out;
}
.accordion-enter-active {
  animation-duration: 1s;
  animation: accordion-open;
}
.accordion-leave-active {
  animation-duration: 1s;
  animation: accordion-open reverse;
}
@keyframes accordion-open {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
